/**
 * Readable-text-color helper (Step 2 extraction).
 *
 * `getTextColor` was copy-pasted (byte-identical logic) into StandardOrder.vue
 * and KioskV2/BuilderScreenV2.vue (and consumed via a function-prop by
 * ModifierPanel). It is pure (hex in, color out) and never touches Vuex or
 * `this`, so it lives here and is unit-tested in isolation.
 */

/**
 * Pick black or white text for a given background hex, using the legacy
 * perceived-brightness threshold. Returns "#333" when no color is supplied.
 *
 * @param {string} hex background color, with or without leading "#"
 * @returns {string} "#333" | "#000000" | "#ffffff"
 */
export function getReadableTextColor(hex) {
  if (!hex) return "#333";
  // Remove #
  hex = hex.replace("#", "");

  // Convert to RGB
  const r = parseInt(hex.substring(0, 2), 16);
  const g = parseInt(hex.substring(2, 4), 16);
  const b = parseInt(hex.substring(4, 6), 16);

  // Calculate brightness
  const brightness = (r * 299 + g * 587 + b * 114) / 1000;

  // Return text color
  return brightness > 150 ? "#000000" : "#ffffff";
}
